import { simplifyFormationTitle } from './formationTitles.mjs';

/**
 * Retire les préfixes bruts (imports Excel) puis applique la version courte du titre.
 */
export function cleanFormationTitle(raw) {
  return simplifyFormationTitle(raw);
}

export { simplifyFormationTitle } from './formationTitles.mjs';

/** Référence catalogue lisible (pas le code auto « MG - LOCATION... ») */
export function formatFormationRef(id) {
  const n = Number(id);
  if (!Number.isFinite(n) || n < 0) return '';
  return `Réf. ${String(n).padStart(4, '0')}`;
}

export function isProgrammeTag(tag) {
  if (!tag || typeof tag !== 'string') return false;
  return tag.includes('Évaluation des Pratiques') || tag.toLowerCase().includes('epp');
}
